module.exports = __webpack_public_path__ + "static/android-chrome-512x512-2389de998b34e2c08a92ed89cf99205d.png";